<script setup>
import axios  from "axios";
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-row>
    <v-col cols="2" v-if="comment.self == 't'" class="px-0" style="position:relative">
        <div class="checkflg_self" v-if="checked == 'false'">未確認</div>
        <div class="checkflg_self" v-else>確認済</div>
    </v-col>
    <v-col>
    <v-card
        flat
        outlined
        width="100%"
        :color="comment_info.color"
        id="comarea"
    >
        <v-card-text :style="'font-size:1.5rem;color:'+comment_info.font" class="px-2 py-3">
            <span class="comm">{{ comment.comment }}</span>
        </v-card-text>
        <v-card-text class="pt-0 pb-2" >
            <span style="display:flex;justify-content: end;">
            <div class="postinfo" :style="'color:'+comment_info.font">
                <span class="contributor">{{ contributor }}</span><span>{{ comment.created }}</span>
            </div>
            </span>
        </v-card-text>
    </v-card>
    </v-col>
    <v-col cols="2" v-if="comment.self == 'f'" class="px-0" style="position:relative">
        <div class="checkflg_partner" v-if="this.user_mode==true || (this.user_mode==false && this.comment_flg==true)">
            <v-checkbox
              v-model="checked"
              color="red"
              value=true
              hide-details
            ></v-checkbox>
        </div>
        <div class="checkflg_partner_flg" v-else-if="checked == 'false'">未確認</div>
        <div class="checkflg_partner_flg" v-else>確認済</div>
    </v-col>
    </v-row>
</template>
<script>
export default {
    props : ['sendcomment',],
	data : function(){
		return {
			comment : {},
		};
	},
    computed : {
        user_kind : function(){
            return this.$store.getters['member_info/get_user_kind'];
        },
        contributor : function(){
            let con = "確認者";
            if(this.comment_flg)
            {
                con = "作成者";
            }
            return con;
        },
        comment_flg : function(){
            let comment_flg = false;
			console.log(this.comment.master);
            if(this.comment.master=='t')
            {
                comment_flg = true;
            }
            return comment_flg;
        },
        comment_info : function(){
            let info = {font:"black",color:"#FAFAFA"};
            if(this.comment.self == 't')
            {
                info.font="white";
                info.color="#2A78FE";
            }
            return info;
        },
		user_mode : function(){
			let mode = false;
			if(this.$route.path=="/edit")
				mode = true;
			return mode;
		},
        self_flg : function(){
            let self_flg = true;
            if(this.user_kind == "ゲスト")
            {
                self_flg = false;
            }
            return self_flg;
        },
        checked : {
            get(){
                let mess = 'false';
                if(this.comment.checkflg=='t')
                {
                    mess = 'true';
                }
                return mess;
            },
            set(newValue)
            {
                if(newValue == 'true')
                {
                    this.comment.checkflg = 't';
                }
                else
                {
                    this.comment.checkflg = 'f';
                }
            }
        },
        checkflg : function(){
            return this.comment.checkflg;
        },
    },
    watch : {
        checkflg : function(){
            this.checkflg_set();
        },
    },
    methods : {
        checkflg_set : async function(){
            var params = new URLSearchParams();
            params.append("id",this.comment.id);
            params.append("checkflg",this.comment.checkflg);
            await axios.post("/doc/set_comment_status",params)
            .then(() => {
            })
            .catch((error) => {
				window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
    },
    created : function(){
		this.comment = this.sendcomment;
    }
}
</script>
<style>
#comarea p{
    font-size : 1.2rem;
    margin : 0;
}
.comm{
    font-size :1.3rem;
    font-weight : 400;
    margin : 0 5px;
}
.checkflg_self{
    font-size : 1rem;
    font-weight : bold;
    position: absolute;
    top:50%;
    right:0;
}


.checkflg_partner_flg{
    font-size : 1rem;
    font-weight : bold;
    position: absolute;
    top:50%;
    left:0;
}

.checkflg_partner{
    font-size : 1rem;
    font-weight : bold;
    top:50%;
    left:0;
}

.contributor{
    font-weight : bold;
    margin-right : 3px;
}
.postinfo{
}
</style>
